import React, { useEffect, useRef, useState, forwardRef, useImperativeHandle } from "react";
import gsap from "gsap";
import "./winningamt.css";
import wincoins from "../../../../../../assets/games/slots/CommanAssets/coinRS.png";
// import Confetti from "react-confetti";

import confetti from "canvas-confetti";

const WinningAmount = ({ targetAmount, setWinsAndAmount }) => {
    const [displayAmount, setDisplayAmount] = useState(0);
    const amountRef = useRef();
    const coinsRef = useRef([]);
    const coinsRef12 = useRef([]);
    const confettiRef = useRef([]);

    const coinsCount = React.useMemo(() => {
        if (targetAmount <= 0) return 0;

        return targetAmount > 50 ? 500 : 10;
        // return Math.min(200, Math.max(10, Math.floor(targetAmount / 50)));
    }, [targetAmount]);

    useEffect(() => {
        let animationFrameId;
        let confettiCanvas = confetti.create(document.createElement("canvas"), {
            resize: true,
            useWorker: true,
        });
        if (targetAmount > 0) {

            // Reset & pop scale in

            //   let count = 0;
            // const interval = setInterval(() => {
            //     confetti({
            //         particleCount: 500,
            //         spread: 180,
            //         startVelocity: 60,
            //         gravity: 1,
            //         origin: { y: 0.6 },
            //     });
            //     count++;
            //     if (count === 5) clearInterval(interval);
            // }, 400);

            const duration = 2 * 1000; // 3 seconds
            const end = Date.now() + duration;

            // (function frame() {
            //     confetti({
            //         particleCount: 100,
            //         startVelocity: 15,
            //         spread: 360,
            //         ticks: 30,
            //         origin: { x: Math.random(), y: Math.random() - 0.2 },
            //     });
            //     if (Date.now() < end) {
            //         requestAnimationFrame(frame);
            //     }
            // })();


            // Continuous side bursts
            confetti({
                particleCount: 1000,
                spread: 180,
                startVelocity: 60,
                origin: { y: 0.7 },
                colors: ["#ffcc00", "#ff6600", "#ffffff"],
            });
            // (function frame() {
            //     confetti({
            //         particleCount: 5,
            //         angle: 60,
            //         spread: 100,
            //         origin: { x: 0, y: 0.8 },
            //         // colors: ["#e4bb18ff", "#d80eceff", "#ffffffff"],
            //     });
            //     confetti({
            //         particleCount: 5,
            //         angle: 120,
            //         spread: 100,
            //         origin: { x: 1, y: 0.8 },
            //         // colors: ["#d80eceff", "#e4bb18ff", "#ffffff"],
            //     });

            //     if (Date.now() < end) {
            //         animationFrameId = requestAnimationFrame(frame);
            //     }
            // })();

            gsap.set(amountRef.current, { scale: 0 });

            gsap.to(amountRef.current, {
                scale: 1.2,
                duration: 0.5,
                ease: "back.out(1.8)",
            });

            const counter = { val: 0 };
            // ----- Dynamic speed calculation -----
            const minDuration = 0.8;   // fastest (huge win)
            const maxDuration = 4;     // slowest (small win)

            // log scale makes big numbers much faster
            const durationAmount =
                Math.max(
                    minDuration,
                    Math.min(
                        maxDuration,
                        maxDuration - Math.log10(targetAmount + 1)
                    )
                );
            gsap.to(counter, {
                duration: durationAmount,
                duration: Math.min(5, targetAmount / 25),
                val: targetAmount,
                ease: "expo.out",
                onUpdate: () => {
                    setDisplayAmount(Math.floor(counter.val));
                },
                onComplete: () => {
                    setDisplayAmount(targetAmount);
                    setTimeout(() => {
                        setWinsAndAmount(0)
                    }, 1500)
                }
            });

            // Coin explosion animation

            playAnimation()
            // sparksAnimate()
            // coinupAnimation()
        }
        return () => {
            cancelAnimationFrame(animationFrameId);
            confetti.reset(); // stop & clear all confetti canvases
            gsap.killTweensOf("*"); // kill all active GSAP tweens
        };
    }, [targetAmount]);

    const playAnimation = () => {
        // Reset all coins
        gsap.set(coinsRef.current, {
            opacity: 0,
            x: 0,
            y: 0,
            scale: 0.6,
            rotation: 0,
        });

        // Animate winning amount
        // const counter = { val: 0 };
        // gsap.to(counter, {
        //   val: winAmount,
        //   duration: 3,
        //   ease: "power2.out",
        //   onUpdate: () => {
        //     const current = Math.min(Math.round(counter.val), winAmount); // never exceed target
        //     setDisplayAmount(current);
        //   },
        //   onComplete: () => setDisplayAmount(winAmount),
        // });

        // Pulse effect on amount only
        // gsap.fromTo(
        //   ".vegas-amount",
        //   { scale: 1 },
        //   { scale: 1.25, duration: 0.6, repeat: -1, yoyo: true, ease: "power1.inOut" }
        // );

        // Coin animation — lasts longer than amount (3s + 1s)
        coinsRef.current.forEach((coin, i) => {
            const angle = (Math.random() - 0.5) * 3;
            const upDistance = 300 + Math.random() * 100;
            // const fallDistance = upDistance + 250 + Math.random() * coinsCount;
            // const sideOffset = 400 + Math.random() * coinsCount;
            const fallDistance = upDistance + 250 + Math.random() * 100;
            const sideOffset = 400 + Math.random() * 200;

            gsap.timeline({ delay: i * 0.01 }) // slightly faster flow
                .to(coin, {
                    opacity: 1,
                    scale: 1,
                    duration: 0.6,
                    ease: "power1.out",
                })
                // Fly upward
                .to(coin, {
                    x: Math.sin(angle) * sideOffset,
                    y: -upDistance,
                    rotation: 360 + Math.random() * 360,
                    duration: 0.5,
                    ease: "power2.out",
                })
                // Fall and fade away
                .to(coin, {
                    y: fallDistance,
                    opacity: 0,
                    rotation: 720 + Math.random() * 360,
                    duration: 1,
                    ease: "power3.in",
                }, "+=0.01");
        });
    }

    const sparksAnimate = () => {
        confettiRef.current.forEach((conf) => {
            if (!conf) return;
            const delay = Math.random() * 0.1;
            const x = (Math.random() - 0.5) * 1500;
            const y = -Math.random() * 500 - 100;
            gsap.fromTo(
                conf,
                { x: 0, y: 0, opacity: 0, rotate: 0 },
                {
                    delay,
                    opacity: 1,
                    rotate: Math.random() * 720,
                    x,
                    y,
                    duration: 1.2,
                    ease: "power2.out",
                    onComplete: () =>
                        gsap.to(conf, {
                            y: "+=600",
                            opacity: 0,
                            duration: 1.2,
                            ease: "power1.in",
                        }),
                }
            );
        });
    }
    const coinupAnimation = () => {
        // --- COIN BURST ---
        coinsRef12.current.forEach((coin) => {
            if (!coin) return;
            const delay = Math.random() * 0.2;
            const x = (Math.random() - 0.5) * 500;
            const y = -Math.random() * 400 - 100;
            gsap.fromTo(
                coin,
                { x: 0, y: 0, opacity: 0, scale: 0.5, rotation: 0 },
                {
                    delay,
                    opacity: 1,
                    scale: 1,
                    rotation: Math.random() * 720,
                    duration: 1,
                    x,
                    y,
                    ease: "power3.out",
                    onComplete: () => {
                        gsap.to(coin, {
                            y: y + 800,
                            opacity: 0,
                            duration: 1.2,
                            ease: "power1.in",
                        });
                    },
                }
            );
        });
    }
    return (
        <div className="RScover containerRS">
            {/* <span className="label_amt">$</span> */}
            <div className="Amount_Main_div">
                <span ref={amountRef} className="amount_RS">
                    {displayAmount}
                </span>
            </div>

            <div className="coin-burst">
                {Array.from({ length: coinsCount }).map((_, i) => (
                    <img
                        key={i}
                        ref={(el) => (coinsRef.current[i] = el)}
                        src={wincoins}
                        className="coin"
                        alt="coin"
                    />
                ))}
            </div>

            {/* <div className="confetti-wrapper">
                {Array.from({ length: 500 }).map((_, i) => (
                    <div
                        key={i}
                        ref={(el) => (confettiRef.current[i] = el)}
                        className="confetti"
                    ></div>
                ))}
            </div> */}

            {/* <div className="coin-wrapper">
                {Array.from({ length: coinsCount }).map((_, i) => (
                    <img
                        key={i}
                        ref={(el) => (coinsRef12.current[i] = el)}
                        src={wincoins}
                        alt="coin"
                        className="coin"
                    />
                ))}
            </div> */}
        </div>
    );
};

export default React.memo(WinningAmount);

